export function AccMark({ className = "h-9" }: { className?: string }) {
  return (
    <svg viewBox="0 0 2000 950" className={className} role="img" aria-label="All Concept Concrete logo">
      <rect width="2000" height="950" fill="#139AF0" />
      <rect x="57" y="57" width="1886" height="836" fill="#fff" />
      <g fill="#139AF0">
        <rect x="157" y="166" width="496" height="618" />
        <rect x="752" y="166" width="496" height="618" />
        <rect x="1347" y="166" width="496" height="618" />
      </g>
      <g fill="#fff">
        <rect x="298" y="307" width="214" height="97" />
        <rect x="298" y="545" width="214" height="239" />
        <rect x="893" y="307" width="355" height="336" />
        <rect x="1488" y="307" width="355" height="336" />
      </g>
    </svg>
  );
}
